import axios from 'axios';
import { SiteForecast } from 'views/planning-prognosis/features/sites/types/site-forecast.type';

// GET
// /ewosapi/v1/planandprognosis/site/{globalSiteId}/forecast
export const getSiteForecast = async (globalSiteId: string, periodType: number = 1): Promise<SiteForecast[]> => {
  const res = await axios.get<SiteForecast[]>(`/ewosapi/v1/planandprognosis/site/${globalSiteId}/forecast?periodType=${periodType}`);
  return res.data;
};
